<script setup>
import { defineEmits, defineProps } from 'vue'

  const props = defineProps({
    pagination: {
      type: Object,
      default: () => ({
        total: 0,
        per_page: 10,
        page: 1
      })
    }
  })

const emit = defineEmits(['current-change'])

const handlePageChange = (page) => {
  emit('current-change', page)
}
</script>

<template>
  <div class="footer">
    共 {{ pagination.total }} 条
    <el-pagination layout="prev, pager, next" :total="pagination.total" :page-size="pagination.per_page"
      :current-page="pagination.page" @current-change="handlePageChange"
      background size="large"/>
  </div>
</template>


<style scoped>
.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 60px;
  margin-top: 10px;
  margin-right: 30px;
  margin-bottom: 10px;
}
</style>